import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const getUtcOffsetFromTimeZone = (timeZone: string): string =>
  dayjs().tz(timeZone).format('Z');
